import React from 'react'

import OpacityTransition from '../../reusable/OpacityTransition'
import { Button } from '../../ui/button'
import {
  Sheet,
  SheetContent,
  SheetDescription,
  SheetHeader,
  SheetTitle,
} from '../../ui/sheet'
import { type Tag } from '../types'
import CreateOrEditTag from './CreateOrEditTag'
import TagManagement from './TagManagement'

type TagManagementProps = {
  isOpen: boolean
  setIsOpen: (isOpen: boolean) => void
}

const TagManagementSheet = ({ isOpen, setIsOpen }: TagManagementProps) => {
  const handleOpenChange = (isOpen: boolean) => {
    setIsOpen(isOpen)
  }

  const [createOrEditTagSettings, setCreateOrEditTagSettings] = React.useState<{
    isOpen: boolean
    tag: Tag | undefined
  }>({ isOpen: false, tag: undefined })

  const { isOpen: isCreateOrEditTagOpen, tag: editableTag } = createOrEditTagSettings

  return (
    <Sheet open={isOpen} onOpenChange={handleOpenChange}>
      <SheetContent className='h-dvh overflow-y-auto'>
        <SheetHeader>
          <SheetTitle className='pb-10'>
            <span className='heading-lg'>Manage Tags</span>
          </SheetTitle>
        </SheetHeader>
        <SheetDescription className='invisible h-0'>
          View, create and archive tags to manage NAV items.
        </SheetDescription>
        {isCreateOrEditTagOpen
          ? (
            <OpacityTransition key='create'>
              <CreateOrEditTag
                tag={editableTag}
                setIsOpen={setCreateOrEditTagSettings}
              />
            </OpacityTransition>
            )
          : (
            <OpacityTransition key='manage'>
              <div className='flex justify-end'>
                <Button
                  onClick={() =>
                    setCreateOrEditTagSettings({ isOpen: true, tag: undefined })}
                >
                  Create Tag
                </Button>
              </div>
              <TagManagement
                setCreateOrEditTagSettings={setCreateOrEditTagSettings}
              />
            </OpacityTransition>
            )}
      </SheetContent>
    </Sheet>
  )
}

export default TagManagementSheet
